import styled from 'styled-components';

import { borderRadius } from '@/theme/selectors';

export const Section = styled.section`
    margin-top: 32px;
`;

export const Container = styled.ul`
    display: flex;
    flex-direction: column;
    margin-top: 8px;
    gap: 8px;
`;

export const Item = styled.li`
    display: flex;
    gap: 12px;
`;

export const Step = styled.div`
    background-color: ${({ theme }) => theme['surface-hovered']};
    border-radius: ${borderRadius('small')};
    width: 100%;
    max-width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
`;
